export default __webpack_public_path__ + "static/media/1661.49793d35.png";